import { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentFocusProperty } from '../../store/selectors';
import { setCurrentFocusProperty } from '../../store/slice';
import { getNavHeightWithScroll } from '../../../worksheet-v2/custom-worksheet-v2/utils';
import SidePanelContainer from './SidePanelContainer';
import useWindowResize from '../../../../hooks/use-window-resize';

function SidePanel(): JSX.Element {
    const dispatch = useDispatch();
    const currentFocusProperty = useSelector(selectCurrentFocusProperty);

    const [isOpen, setIsOpen] = useState(currentFocusProperty !== undefined);

    const sidebarNav = useRef<HTMLDivElement>(null);

    const { width } = useWindowResize();
    const overlaySidebar = width <= 1300;

    useEffect(() => {
        setIsOpen(currentFocusProperty !== undefined);
    }, [currentFocusProperty]);

    function handleClose(): void {
        setIsOpen(false);
        dispatch(setCurrentFocusProperty(undefined));
    }

    return (
        <div className={overlaySidebar ? 'fixed top-14 right-0' : ''}>
            <div
                ref={sidebarNav}
                style={{ height: getNavHeightWithScroll(sidebarNav.current) }}
                className={`flex flex-col ${
                    overlaySidebar ? 'absolute top-0 right-0 px-4 bg-white' : 'top-0 sticky'
                } overflow-x-hidden overflow-y-auto min-w-max overscroll-contain`}
            >
                <AnimatePresence initial={false}>
                    {isOpen && (
                        <motion.aside
                            transition={{ duration: 0.2 }}
                            initial={{ minWidth: 0, width: 0 }}
                            animate={{ minWidth: 350, width: 350 }}
                            exit={{ minWidth: 0, width: 0 }}
                        >
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1, transition: { duration: 0.05, delay: 0.175 } }}
                                exit={{ opacity: 0, transition: { duration: 0 } }}
                            >
                                <SidePanelContainer onClose={handleClose} propertyId={currentFocusProperty} />
                            </motion.div>
                        </motion.aside>
                    )}
                </AnimatePresence>
            </div>
        </div>
    );
}

export default SidePanel;
